<template>
    <v-card style="height: 400px;">
        <v-card-title>
            Pending Approvals <v-icon  v-if="!loading" @click="getLeaveCount">mdi-refresh</v-icon>
        </v-card-title>

        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

        <v-card-text style="height:320px;overflow-y:auto;">
            <!-- pending leave requests -->
            <v-list v-if="items && items.pending_approval_leaves && items.pending_approval_leaves.length" dense>
                <v-subheader class="primary--text">Leaves</v-subheader>
                <v-list-item v-for="item in items.pending_approval_leaves" :key="item.label" :to="item.to" class="px-0" style="border-bottom: 1px solid #ddd !important;">
                    <v-list-item-content>
                        <v-list-item-subtitle class="d-flex justify-space-between align-center">
                            <span>{{item.label}}</span>
                            <v-chip small>{{item.count}}</v-chip>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <!-- my pending leave requests -->
            <v-list dense>
                <v-subheader class="primary--text">My Leave Requests</v-subheader>
                <template v-if="items && items.my_pending_leaves && items.my_pending_leaves.length">
                    <v-list-item v-for="item in items.my_pending_leaves" :key="item.id" class="px-0" style="border-bottom: 1px solid #ddd !important;" to="/leaves/requests">
                        <v-list-item-content>
                            <v-list-item-title v-if="item.leave_type">
                                {{ item.leave_type.cEngLeaveName }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="d-flex flex-column flex-sm-row justify-space-between overflow-wrap">
                                <span>
                                    Applied at: {{ $localeDateTime(item.submitted_at) }}
                                </span>
                                <span>
                                    <v-icon small color="primary">mdi-calendar-outline</v-icon>
                                    {{ $localeDate(item.from_date) }}
                                    - {{ $localeDate(item.to_date) }}
                                    <!-- {{ (new Date(item.end)).toLocaleString('en-GB').substr(0,17) }} -->
                                </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <div v-else class="text-center grey--text">
                    No pending leave requests...
                </div>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        loading: false,
        items: []
    }),
    methods: {
        getLeaveCount() {
            this.loading = true
            this.$axios.get(`/api/dashboard/getPending`).then((resp) => {
                this.items = resp.data
            }).finally(() => this.loading = false)
        },
    },
    mounted() {
        this.getLeaveCount()
    },
}
</script>

<style>
.v-subheader.theme--light {
    padding-left: 0;
}
</style>